import { Component } from '@angular/core';
import type { OnInit } from '@angular/core';
// import * as firebase from 'firebase';
// import firebase from 'firebase/app';
// import 'firebase/functions';
import { initializeApp } from 'firebase/app';
import { getFunctions, httpsCallable } from 'firebase/functions';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';

import { environment } from '@shared/environment';
import { UtilsService, UxHelperService } from '@shared/services';
import type { TCustomer } from '@shared/models';

@Component({
    'selector': 'app-campaignOptout',
    'templateUrl': './campaignOptout.page.html',
    'styleUrls': ['./campaignOptout.page.scss'],
    'standalone': true,
    'imports': [ CommonModule, FormsModule, IonicModule ]
})
export class CampaignOptoutPage implements OnInit {
    public customer: TCustomer;
    //  = {
    //     customerName: '',
    //     isActive: true
    // };
    private vm: any = {
        accountNumber: '',
        customerUid: ''
    };
    private functions;

    constructor(private uxHelperService: UxHelperService, private utilsService: UtilsService) {
        const firebaseConfig = environment.firebase;
        const app = initializeApp(firebaseConfig);
        this.functions = getFunctions(app);
    }

    // http://localhost:8100/showCampaign?an=00000-0000-00000&cuid=6hI90k0HrC84gdyz4hBo
    // app.ShuttleNomix.com/showCampaign?an=00000-0000-00000&cuid=6hI90k0HrC84gdyz4hBo
    // staging.ShuttleNomix.com/showCampaign?an=00000-0000-00000&cuid=6hI90k0HrC84gdyz4hBo
    // http://localhost:8100/showCampaign?an=00000-0000-00000&cuid=6hI90k0HrC84gdyz4hBo
    // http://localhost:8100/campaignOptout?accountNumber=00000-0000-00000&cellPhone=6618778631
    async ngOnInit(): Promise<void> {
        const urlParams = new URLSearchParams(window.location.search);
        const anParmExists = urlParams.has('an');
        const cuidParmExists = urlParams.has('cuid');

        if (anParmExists) {
            this.vm.accountNumber = urlParams.get('an');
        }
        if (cuidParmExists) {
            this.vm.customerUid = urlParams.get('cuid');
        }

        // this.vm.accountNumber = '00000-0000-00000';
        // this.vm.customerUid = '6hI90k0HrC84gdyz4hBo';

        try {
            await this.uxHelperService.showSpinner('Loading data.');
            this.customer = await this.getCustomer();
        } catch (err) {
            const errorMessage = this.utilsService.extractError(err);
            this.uxHelperService.showAlert('Error', errorMessage);
        } finally {
            await this.uxHelperService.hideSpinner();
        }
    }

    // This method should really go in FirebaseFunctionsService.  The problem is the constructor
    // requires
    public async getCustomer(): Promise<TCustomer> {
        // const func = firebase.functions().httpsCallable('getCustomer');
        const func = httpsCallable(this.functions, 'GetCustomer');
        const parms = { 'accountNumber': this.vm.accountNumber, 'customerUid': this.vm.customerUid };
        const result = await func(parms);
        const customer = result.data as TCustomer;
        return customer;
    }

    public async onOptoutClick() {
        try {
            await this.uxHelperService.showSpinner();
            // const func = firebase.functions().httpsCallable('campaignOptout');
            const func = this.functions().httpsCallable('campaignOptout');
            const parms = { 'accountNumber': this.vm.accountNumber, 'customerUid': this.vm.customerUid };
            const result = await func(parms);
            this.customer = result.data.customer;
        } catch (err) {
            const errorMessage = this.utilsService.extractError(err);
            this.uxHelperService.showAlert('Error', errorMessage);
        } finally {
            await this.uxHelperService.hideSpinner();
        }
    }
}
